import BoardsContainer from './BoardsContainer';
export default BoardsContainer;
